import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import './formLogin.css';

import LogoBot from '../../img/logoBot.png';
import DemoBot from '../../img/demoBot.png';

import LogoUser from '../../img/logoUser.png';
import LogoPass from '../../img/logoPassword.png';

import * as firebase from 'firebase';
const auth = firebase.auth();

class FormLogin extends Component {

    constructor(props){
        super(props);

        this.state = {
            error: false
        }

        this.user = null;
        this.pass = null;
    }

    capturarEnter = (e) => {
        let element = e.key;

        if(element && element === 'Enter'){
            this.login();
        }
    }

    login = () => {
        this.setState({
            error: false
        })
        
        if(this.user.value && this.pass.value){
            auth.signInWithEmailAndPassword(this.user.value, this.pass.value).then((res) => {
                    // this.props.history.push('/admin/dashboard/');
                // console.log('Éxito');
            }).catch((r) => {
                this.setState({
                    error: true
                })
            })
        }
    }



    render(){
        return(
            <div className='formLogin col s12 m12 x12'>
                <div className='row'>
                    <div className='col s12 m6 x6 camposLogin'>
                        <div className='col s12 m12 x12 centrarContenido'>
                            <img className='logoBot' src={LogoBot} alt='logoBot'/>
                        </div>
                        <div className='col s12 m12 x12'>
                            <div className="input-field">
                                <img className='imgInput' src={LogoUser} alt='user'/>
                                <input placeholder="Usuario" type="email" className="validate" ref={element => this.user = element} />
                            </div>
                        </div>
                        <div className='col s12 m12 x12'>
                            <div className="input-field">
                                <img className='imgInput' src={LogoPass} alt='user'/>
                                <input placeholder="Contraseña" type="password" className="validate" ref={element => this.pass = element} onKeyPress={this.capturarEnter}/>
                            </div>
                        </div>
                        { this.state.error ? <p className="error">Nombre de usuario o contraseña incorrecta</p> : null}
                        <div className='col s12 m12 x12 contenedorBtnGuardar'>
                            <div className="btnIngresar" onClick={this.login}>
                                <p>INGRESAR</p>
                            </div>
                        </div>
                    </div>
                    <div className='col s12 m6 x6'>
                        <div className='contenedorDemoBot'>
                            <img className='demoBot' src={DemoBot} alt="demoBot"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(FormLogin);